/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersService } from 'src/app/services/users/users.service';
import { TranslateService } from '@ngx-translate/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Error } from 'src/app/models/error.model';
import { UserInfo } from 'src/app/models/user-info.model';
import { lastValueFrom } from 'rxjs';
import { UpiService } from 'src/app/services/upi/upi.service';
import { Upi } from 'src/app/models/upi.model';

@Component({
  selector: 'app-user-update-dialog',
  templateUrl: './user-update.component.html',
  styleUrls: ['./user-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserUpdateComponent {
  currentUser: UserInfo = new UserInfo();
  currentUserAvs: string;
  error: Error = { error: { message: '', code: '' } };
  isBusyVerifyAvs = false;
  isInfoIncorrect = false;
  isInfoCorrect = false;
  userAlreadyExistsWithAvs = false;
  avsValidator = '[0-9]{3}\\.[0-9]{4}\\.[0-9]{4}\\.[0-9]{2}';
  dateOfBirthValidation =
    '^([0]?[1-9]|[1|2][0-9]|[3][0|1])[.]([0]?[1-9]|[1][0-2])[.]([0-9]{4}|[0-9]{2})$';
  NameNotNumberValidation = '^([^0-9]*)$';

  newUser: Upi;

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  changeAvsForm: FormGroup;

  constructor(
    public matDialogRef: MatDialogRef<UserUpdateComponent>,
    @Inject(MAT_DIALOG_DATA) _data: { currentUserAvs: string },
    private _formBuilder: FormBuilder,
    private _userService: UsersService,
    private _translateService: TranslateService,
    private _upiService: UpiService
  ) {
    this.currentUserAvs = _data.currentUserAvs;
    this.changeAvsForm = this._formBuilder.group({
      avs: ['', [Validators.required, Validators.pattern(this.avsValidator)]],
      officialLastName: ['', Validators.pattern(this.NameNotNumberValidation)],
      dateOfBirth: [
        '',
        [Validators.required, Validators.pattern(this.dateOfBirthValidation)],
      ],
    });
  }

  async getUpiInfo() {
    this.isBusyVerifyAvs = true;
    this.isInfoIncorrect = false;
    this.isInfoCorrect = false;
    this.userAlreadyExistsWithAvs = false;
    try {
      const dateOfBirthFragments = this.dateOfBirth.split('.');
      const upiUser = await lastValueFrom(
        this._upiService.getUpiOnMatch(
          this.avs,
          this.officialLastName,
          `${dateOfBirthFragments[2]}-${dateOfBirthFragments[1]}-${dateOfBirthFragments[0]}`
        )
      );
      if (upiUser) {
        this.newUser = upiUser;
        this.newUser.avs = this.avs;
        this.newUser.sex == 1
          ? (this.newUser.sexAcronym = 'M')
          : (this.newUser.sexAcronym = 'F');
        this.isInfoCorrect = true;
      } else {
        this.isInfoIncorrect = true;
      }
    } catch {
      // Empty
    } finally {
      if (await this.verifyIfAvsAlreadyInUse()) {
        this.userAlreadyExistsWithAvs = true;
      }
      this.isBusyVerifyAvs = false;
    }
  }

  async createNewUser() {
    this.newUser = await lastValueFrom(
      this._upiService.getUpiInfoByAVS(this.avs)
    );
    this.newUser.avs = this.avs;
    this.newUser.sex == 1
      ? (this.newUser.sexAcronym = 'M')
      : (this.newUser.sexAcronym = 'F');
  }

  async verifyIfAvsAlreadyInUse(): Promise<boolean> {
    if (this.avs === this.currentUserAvs) {
      return Promise.resolve(false);
    }

    return await lastValueFrom(this._userService.isAvsAlreadyInUse(this.avs));
  }

  importNewUserData() {
    this.matDialogRef.close(this.newUser);
  }

  get avs(): string {
    return this.changeAvsForm.get('avs').value;
  }

  get officialLastName(): string {
    return this.changeAvsForm.get('officialLastName').value;
  }

  get dateOfBirth(): string {
    return this.changeAvsForm.get('dateOfBirth').value;
  }
}
